import { TramiteExclusionService } from 'src/app/users/tramites/tramite-exclusion/tramite-exclusion.service';
import {
    Component, computed,
    Input,
    OnInit,
    signal,
    ViewChild,
    WritableSignal
} from '@angular/core';
import {
    ArchivoItem,
    EventItem,
    ProyectoItem
} from '../../../interfaces/proyecto.interface';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DatePipe, Location } from '@angular/common';
import { Table } from "primeng/table";
import { ProyectoService } from "../../services/proyecto.service";
import { ActivatedRoute, Router } from "@angular/router";
import { TramiteService } from "../../../tramites/services/tramite.service";
import { environment } from "../../../../../environments/environment.development";
import { LoginServices } from "../../../../auth/login/services/login.service";
import {
    UsuarioAsignado
} from "../../../../officials/asignaciones/interfaces/asignacion-interface";
import { AsignacionesService } from "../../../../officials/asignaciones/services/asignaciones.service";
import { CalendarEvent } from "../../../../shared/interfaces/shared-interface";
import { CalendarEventService } from "../../../../shared/components/calendar/CalendarEventService";
import { map } from "rxjs";
import { ViewerInterface } from "../../../../shared/interfaces/viewer-interface";
import { ProyectoDataService } from "../../services/proyecto-data.service";
import { RandomSessionIdService } from "../../../../guards/random-session-id.service";
import { EvalInterface } from "../../../../officials/evaluaciones/interfaces/evaluaciones.interface";
import { EvaluacionesService } from "../../../../officials/evaluaciones/services/evaluaciones.service";
import Swal from "sweetalert2";
import { ApiResponse_Error, ApiResponse_handleLabelValuesEmpty, ObtencionGenerica } from './interface/ver-proyecto.interface';
import { TramiteExclusionRes } from 'src/app/users/tramites/tramite-exclusion/interface/TramiteExclusionRes';
import CONSTANTS from 'src/utils/resources/constants';

const apiVucUrl = environment.apiVucUrl

@Component({
    selector: 'app-ver-proyecto',
    templateUrl: './ver-proyecto.component.html',
    styleUrls: ['./ver-proyecto.component.css'],
    providers: [ConfirmationService, MessageService, DatePipe]
})
export class VerProyectoComponent implements OnInit {
    proyectos: ProyectoItem[] = [];
    selected: ProyectoItem | null = null;
    archivos: ArchivoItem[] = []
    activeIndex: number = 0;
    timelineEvents: EventItem[];
    exclusionesCargadas: boolean = false;
    errorCargandoExclusiones: boolean = false;
    tramiteExclusiones: TramiteExclusionRes[] = [];
    private yaSeCargaronTramitesExcluidos: boolean = false;

    /**
     * Usuarios asignados previamente a la solicitud
     */
    private _assignedUsers: WritableSignal<UsuarioAsignado[]> = signal([])
    events: WritableSignal<CalendarEvent[]> = signal([])
    pageLoad: WritableSignal<boolean> = signal(true)
    viewer!: ViewerInterface
    dialogPdfView = false;
    displayImgView: boolean = false;
    sessionId: string | null
    openDialogEvaluacion: boolean = false;
    evaluacion!: EvalInterface
    @Input() _showLoader: boolean = false
    @ViewChild('viewer', { static: false }) public embeddedPdfViewer: { pdfSrc: string; downloadFileName: string; } | any;



    /*===========================================================================================*/
    /*VARIABLES ---------------------------------------------------------------------------------*/
    /*===========================================================================================*/
    private consoleEnabled: boolean = CONSTANTS.consoleEnabled; // Cambiar a false para desactivar los logs de consola



    /*Recuperacion de los datos de la solicitud --------------------------------------------------*/



    registroProfesional_Solicitud_Exist: boolean = false;

    registroProfesional_Solicitud: ObtencionGenerica = {
        "idRegProfSolicitud": 0,
        "tipoPersona": "",
        "nacionalidad": "",
        "tipoDocumento": "",
        "documento": "00000000-0",
        "nombreCompletoPersona": "",
        "ambito": "",
        "profesion": "",
        "clasificacion": "",
        "nivelAcademico": "",
        "tituloObtenido": "",
        "centroEstudio": "strng",
        "fechaGraduacion": "2000-01-01",
        "paisEstudio": "",
        "carnetActual": "",
        "fechaVencimientoCarnet": "2000-01-01",
        "flujoTramite": "",
        "solicitud": 0,
        "estado": ""
    };



    /*Recuperacion de los datos de los antecedentes ---------------------------------------------*/



    registroProfesional_Antecedentes: ObtencionGenerica[] = [{
        "institucion": "",
        "numDocumento": "00000000-0",
        "profesion": "",
        "nombres": "",
        "apellidos": "",
        "nacionalidad": "",
        "carnet": null,
        "fechaOtorgamientoPermiso": null,
        "fechaVencimientoPermiso": "2000-01-01"
    }];

    registroProfesional_Antecedentes_exist: boolean = false;




    /*===========================================================================================*/
    /*CONSTRUCTOR -------------------------------------------------------------------------------*/
    /*===========================================================================================*/



    constructor(
        private route: ActivatedRoute,
        private proyectoServices: ProyectoService,
        private location: Location,
        private proyecto: ProyectoService,
        public tramite: TramiteService,
        public asignacionesService: AsignacionesService,
        public loginServices: LoginServices,
        public calendarEventService: CalendarEventService,
        protected proyectoDataService: ProyectoDataService,
        public rs: RandomSessionIdService,
        protected evaluacionesService: EvaluacionesService,
        private messageService: MessageService,
        public router: Router,
        private confirmationService: ConfirmationService,
        private tramiteExclusionService: TramiteExclusionService
    ) {
        console.log(this.route.url)
        this.timelineEvents = [];
        this.sessionId = rs.randomSessionId();
    }



    /*===========================================================================================*/
    /*LIFE-CYCLE --------------------------------------------------------------------------------*/
    /*===========================================================================================*/



    ngOnInit(): void {
        this.preFetchProyectoId();
        this.fetchProyectoFromRoute();
        this.fetchTramitesPorProyecto();
        this.fetchTimeLineEvents();
        this.fetchTecnicosAsignados();
        this.fetchEventsByIdProyecto();
        this.fetchRequisitosActivosByIdProyecto();
        this.obtenerTramitesFasesEvaluacion();
    }

    ngOnDestroy(): void {
        this.proyectoDataService.tramitesPorProyecto.set([]);
    }



    /*===========================================================================================*/
    /*CUSTOM LIFE-CYCLE -------------------------------------------------------------------------*/
    /*===========================================================================================*/



    async onProyectLoaded(proyecto: ProyectoItem): Promise<void> {

        /* ------------------------------------------------------------------------------------- */

        if (this.consoleEnabled) {console.log("YA SE CARGO EL ID SOLICITUD Y EL PROYECTO COMPLETO", proyecto.idSolicitud);}

        /* ------------------------------------------------------------------------------------- */

        /**
         * Procediente a cargar los datos del registro profesional para la tab llamada
         * como: {Datos de Solicitud}. Posterior a ello en caso de exito, se pocede a
         * cargar los datos de los antecedentes a partir del numero de documento, esto
         * ejecutado mediante un callback de success
         * */
        this.cargarRegistroProfesional(proyecto.idSolicitud, () => {
            if (this.consoleEnabled) {console.log("PROCEDIENDO A CARGAR DATOS DE LOS ANTECEDENTES");};


            this.cargarRegistroProfesional_Antecedentes(this.registroProfesional_Solicitud["documento"]);
        });

        /* ------------------------------------------------------------------------------------- */

        /**
         * Hola Javier... Parece que tu hiciste el llamado de esta funcion. He movido
         * a esta posicion tu metodo ya que este esta mejor optimizado para recuperar
         * los datos del proyecto, entre ellos el idSolicitud que el proyecto trae.
         * Elimina este comentario si lo necesitas
        */
        this.cargarTramitesExcluidos(proyecto.idSolicitud);
    }



    /*===========================================================================================*/
    /*METHODS -----------------------------------------------------------------------------------*/
    /*===========================================================================================*/


    /* validar si en seleccionado el nombre inicia con {RP_} o no */
    get isRegistroProfesional(): boolean {
        return this.selected?.nombre?.startsWith('RP_') || false;
    }

    verTramitesExclusiones(): boolean {
        return this.loginServices.hasRoles(['gerente', 'tecnico_resolutor']);
    }
    onEstadoActualizado(): void {
        if (this.selected?.idSolicitud) {
            this.cargarTramitesExcluidos(this.selected.idSolicitud);
        }
    }
    esSeleccionable(proyecto: ProyectoItem): boolean {
        const estado = proyecto.estadoSolicitud?.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        return estado === 'cancelacion' || estado === 'cancelada';
    }

    //TramitesExcluidos
    private cargarTramitesExcluidos(idSolicitud?: number): void {
        if (this.yaSeCargaronTramitesExcluidos) return;

        this.exclusionesCargadas = false;
        this.errorCargandoExclusiones = false;

        if (!idSolicitud) {
            this.tramiteExclusiones = [];
            return;
        }

        if (!this.verTramitesExclusiones()) {
            this.tramiteExclusiones = [];
            this.messageService.add({
                severity: 'warn',
                summary: 'Sin permisos',
                detail: 'No tiene permisos para ver los trámites excluidos.'
            });
            return;
        }
/*
        this.tramiteExclusionService.mostrarExclusionSolicitud(idSolicitud).subscribe({
            next: (res) => {
                this.tramiteExclusiones = res || [];
                this.exclusionesCargadas = true;
                this.yaSeCargaronTramitesExcluidos = true;
            },
            error: (err) => {
                console.error('Error cargando exclusiones:', err);
                this.tramiteExclusiones = [];
                this.errorCargandoExclusiones = true;

                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'No se pudieron cargar los trámites excluidos.'
                });
            }
        }); */
    }



    /**
     * Carga los datos del registro profesional asociado a una solicitud.
     */
    private async cargarRegistroProfesional(idSolicitud: number | undefined, onSuccess?: CallableFunction): Promise<void> {

        // Validación inicial
        if (!idSolicitud) {
            if (this.consoleEnabled) {
                console.warn('ID de solicitud no disponible aún');
            }
            return;
        }

        this.registroProfesional_Solicitud_Exist = false;

        try {
            const data = await this.proyecto.getRegistroProfesional_Solicitud(idSolicitud).toPromise();

            if (this.consoleEnabled) {
                console.log('Datos obtenidos de registro profesional:', data);
            }


            // Procesar respuesta
            if (data?.success) {
                this.registroProfesional_Solicitud = ApiResponse_handleLabelValuesEmpty(
                    data.data,
                    this.registroProfesional_Solicitud
                );
            }


            this.registroProfesional_Solicitud_Exist = true;

            // Validar número de documento
            const numDocumento = this.registroProfesional_Solicitud["documento"]?.trim();
            if (!numDocumento || numDocumento === '00000000-0') {
                this.registroProfesional_Antecedentes_exist = false;
                return;
            }

            if (onSuccess) onSuccess()
        } catch (error) {
            this.registroProfesional_Solicitud_Exist = false;

            if (this.consoleEnabled) {
                console.error('Error al cargar datos del registro profesional:', error);
            }

            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'No se pudieron cargar los datos del registro profesional.'
            });
        }
    }


    // Método para cargar datos del registro profesional
    private async cargarRegistroProfesional_Antecedentes(numDocumento: string): Promise<void> {
        if (!this.registroProfesional_Solicitud_Exist) {
            if (this.consoleEnabled) {console.warn('ID de solicitud no disponible aún');}
            return;
        }


        console.log('numDocumento identificado que ha pasado pruebas:', numDocumento);


        try {

            const res = this.proyecto.getRegistroProfesional_Tramite(numDocumento).subscribe(response => {
                if (response.success) {


                    if (this.consoleEnabled) {console.log('Datos obtenidos de antecedentes:', response.data);}


                    this.registroProfesional_Antecedentes = response?.data
                    ? response.data.map((item: any) => {
                          const convertedItem = ApiResponse_handleLabelValuesEmpty(item, undefined);
                          return convertedItem; // Convertir fechas a cadenas locales
                      })
                    : this.registroProfesional_Antecedentes;

                if (this.consoleEnabled) {
                    console.log('Datos obtenidos de antecedentes 2:', this.registroProfesional_Antecedentes);
                }
                    this.registroProfesional_Solicitud_Exist = true;
                    this.registroProfesional_Antecedentes_exist = true;
                } else {
                    this.registroProfesional_Antecedentes_exist = false;
                }
            });

            console.log("response:", res);


        } catch (error) {
            console.error('Error al cargar datos de los Antecedentes:', error);
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'No se pudieron cargar los datos de los Antecedentes.'
            });
        }
    }


    prjId$ = this.route.params.pipe(map((params) => params['idProyecto']));



    private preFetchProyectoId() {
        console.log(`preFetchProyectoId`)
        this.prjId$.subscribe((id) => {
            if (id) {//load everything prj sequence.
                this.tramite.idProyecto.set(id)
            }
        });
        console.log(`params -> this.tramite.idProyecto  -> ${this.tramite.idProyecto()}`)
    }

    fetchProyectoFromRoute() {
        console.log(`fetchProyectoFromRoute...${this.tramite.idProyecto()}`)
        this.proyectoServices.getGeneralesProyecto(this.tramite.idProyecto())
            .subscribe({
                next: (result) => {
                    this.proyectos = result.body!;
                    if (this.proyectos != null) {
                        this.selected = this.proyectos[0];



                        if(this.consoleEnabled) {console.log('Proyecto seleccionado:', this.selected);}


                        // Aqui ya hay id para cargar a la tabla
                        if (this.selected?.idSolicitud && this.verTramitesExclusiones()) {
                            console.log("Ya se cargo el id solicitud", this.selected.idSolicitud);
                            this.cargarTramitesExcluidos(this.selected.idSolicitud);
                        }

                        if (this.selected?.idSolicitud) {
                            this.onProyectLoaded(this.selected)
                        }
                    }
                },
                error: (error) => {
                    console.log(error)
                    setTimeout(() => {
                        this.pageLoad.set(false)
                    }, 10);
                },
                complete: () => {
                    setTimeout(() => {
                        this.pageLoad.set(false)
                    }, 200);
                }
            });
    }

    fetchTramitesPorProyecto() {
        console.log(`fetchTramitesPorProyecto...${this.tramite.idProyecto()}`)
        this.proyecto.getTramitesProyectos(parseInt(this.tramite.idProyecto()!, 10))
            .subscribe({
                next: (result) => {
                    this.proyectoDataService.tramitesPorProyecto.set(result.body!);
                },
                error: (error) => {
                    console.log(error)
                }
            });
    }

    fetchArchivosProyecto() {
        console.log(`fetchArchivosProyecto...${this.tramite.idProyecto()}`)
        if (this.tramite.idProyecto() != null) {
            this.proyectoServices.getArchivosProyecto(parseInt(this.tramite.idProyecto()!, 10))
                .subscribe({
                    next: (result) => {
                        console.log('result.body!', result)
                        this.archivos = result.body!;
                    },
                    error: (error) => {
                        console.log(error)
                    }
                });
        }
    }

    obtenerTramitesFasesEvaluacion() {
        if (this.tramite.idProyecto() !== null) {
            this.tramite.getTramitesFasesEvaluacion(Number.parseInt(this.tramite.idProyecto()!));
        }
    }

    onTabChange({ event }: { event: any }) {
        console.log(`onTabChange.${JSON.stringify(event)}`)
        if (this.activeIndex != null && this.activeIndex == 0) {
            this.fetchTramitesPorProyecto();
        } else if (this.activeIndex != null && this.activeIndex === 1) {
            this.fetchArchivosProyecto();
        } else if (this.activeIndex != null && this.activeIndex === 2) {
            this.fetchRequisitosActivosByIdProyecto();
        }else if(this.activeIndex !== null && this.activeIndex == 3){
            this.cargarTramitesExcluidos();
        }
    }

    downloadFileNewTab(hash: string) {
        console.log(`downloadFile with hash ->${hash}`)
        window.open(`${apiVucUrl}api/v1.0/archivos/${hash}`, "_blank");
    }

    onSubmit() {
        console.log(`onSubmit.${this.tramite.idProyecto()}`);
    }

    goBack(): void {
        this.location.back();
    }

    clear(table: Table) {
        table.clear();
    }
    private fetchTimeLineEvents() {
        if (this.tramite.idProyecto() != null && this.tramite.idProyecto()!.length > 0) {
            this.proyecto.getTimeLine((parseInt(this.tramite.idProyecto()!, 10)))
                .subscribe({
                    next: (result) => {
                        if (result && result.body) {
                            this.timelineEvents = result.body;
                        }
                    },
                    error: (error) => {
                        console.log(error)
                    },
                    complete: () => {
                        console.log('this.timelineEvents = ', this.timelineEvents.length);
                    }
                });
        }
    }

    private fetchTecnicosAsignados() {
        this._assignedUsers.set([])
        if (this.tramite.idProyecto() != null && this.tramite.idProyecto()!.length > 0) {
            if (this.loginServices.hasRoles(['ministro', 'gerente', 'jefe'])) {//Funcionarios gerenciales
                this.asignacionesService.consultarAsignacionProgreso(Number.parseInt(this.tramite.idProyecto()!))
                    .subscribe({
                        next: (result) => {
                            this._assignedUsers.set(result.body!)
                        },
                        error: (error) => {
                            console.log(error)
                        },
                        complete: () => {
                        }
                    });
            }
        }
    }

    fetchEventsByIdProyecto() {
        this.calendarEventService.getEventosByIdProyecto(this.tramite.idProyecto()!)
            .subscribe({
                next: (result) => {
                    this.events.set(result.body!);
                },
                error: (error) => {
                },
                complete: () => {
                }
            });
    }

    openFileInViewer(archivo: ArchivoItem, call: number) {
        this.viewer = {
            idRequisito: "null",
            nombre: archivo.nombre!,
            hash: archivo.hash!,
            idTipoArchivo: archivo.idTipoArchivo!,
            ext: archivo.ext!
        }
        if (this.viewer && this.viewer !== null) {
            if (call == 1) {
                this._showLoader = true;
                this.displayImgView = true;
            } else {
                this.dialogPdfView = true;
                this._showLoader = true
                setTimeout(() => {
                    if (this._showLoader) {
                        this._showLoader = false
                    }
                }, 600);
            }
        }
    }
    handleItemClicked({ evalu, event }: { evalu: EvalInterface, event: Event }) {
        this.evaluacion = evalu
        console.log('clicked:', this.evaluacion);
    }

    fetchRequisitosActivosByIdProyecto() {
        this.tramite.getRequisitosPorParametros(null, this.tramite.idProyecto()!, null)
    }

    get assignedUsers(): WritableSignal<UsuarioAsignado[]> {
        return this._assignedUsers;
    }

    set assignedUsers(value: WritableSignal<UsuarioAsignado[]>) {
        this._assignedUsers = value;
    }

    closeViewerPdf(event: boolean): void {
        this.dialogPdfView = event;
    }

    closeViewerImg(event: boolean): void {
        this.displayImgView = event
    }

    openDialogoEval(event: Event, clickEvent: (e: Event) => void) {
        if (clickEvent) {
            clickEvent(event);
            this.openDialogEvaluacion = true;
        }
    }
    closeDialogEvaluacion() {
        this.openDialogEvaluacion = false;
    }
    isDisabledEval(idEstadoSolicitud: number): boolean {
        let estado = false;
        if (idEstadoSolicitud !== null && idEstadoSolicitud !== undefined) {
            if (idEstadoSolicitud > 2) {
                estado = true;
            }
        }
        return estado;
    }
    totalProgress = computed(() => {
        const users = this._assignedUsers();
        if (users.length === 0) {
            return 0;
        }
        let totalProgress = 0;
        users.forEach(user => {
            totalProgress += user.progresoEval != null ? user.progresoEval : 0;
        });
        const result = totalProgress / users.length;
        return parseFloat(result.toFixed(2));
    });
}
